import React, { useState, useCallback, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../FormInput/FormInput';
import css from './ToggleInput.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../../common/utils/styles';

const ToggleFormInput = (props) => {
    const { attribute, title, buttonsAttribute, options, defaultValue, disabled, compStyle, setFormData, value } = props;
    const [btnValue, setBtnValue] = useState(defaultValue || null);
    const [val, setVal] = useState(value);
    const inputPlaceholder = useMemo(
        () => (options.find((item) => item.id === btnValue) ? options.find((item) => item.id === btnValue).placeholder : ''),
        [btnValue, options]
    );
    const inputTitle = useMemo(
        () => (options.find((item) => item.id === btnValue) ? options.find((item) => item.id === btnValue).name : ''),
        [btnValue, options]
    );
    const inputType = useMemo(
        () => (options.find((item) => item.id === btnValue) ? options.find((item) => item.id === btnValue).type : ''),
        [btnValue, options]
    );
    const isSocial = useMemo(
        () => (options.find((item) => item.id === btnValue) ? options.find((item) => item.id === btnValue).isSocial : ''),
        [btnValue, options]
    );
    const changeBtnHandler = useCallback(
        (v) => {
            if (!disabled) {
                setFormData(buttonsAttribute, v);
                setBtnValue(v);
                setFormData(attribute, null);
                setVal(null);
            }
        },
        [disabled, attribute, setFormData, buttonsAttribute]
    );

    const [memoizedOptions] = useState(options);

    useEffect(() => {
        setBtnValue(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        setVal(value);
    }, [value]);

    const { stylers, classes } = generateCompStylers(props?.compStyle);

    return (
        <>
            <FormInput
                {...props}
                setFormData={(attr, val) => {
                    setVal(val);
                    setFormData(attr, val);
                }}
                value={val}
                buttons={memoizedOptions.reduce(
                    (acc, item) => ({
                        ...acc,
                        [item.id]: {
                            handler: () => {
                                changeBtnHandler(item.id);
                            },
                            icon: item.icon
                        }
                    }),
                    {}
                )}
                type={inputType || 'input'}
                placeholder={inputPlaceholder || ''}
                title={inputTitle ? { body: inputTitle } : title}
                customData={{
                    ...props.customData,
                    ...(isSocial ? { isSocial } : {})
                }}
                compStyle={{
                    ...compStyle,
                    content: {
                        className: classnames(css.toggleInputContentMobile, classes.content),
                        ...stylers.content
                    },
                    inner: {
                        className: classnames(css.toggleInputInnerMobile, classes.inner),
                        ...stylers.inner
                    },
                    ...options.reduce(
                        (acc, item) => ({
                            ...acc,
                            [item.id]: {
                                button: {
                                    className: classnames(
                                        css.toggleInputButton,
                                        classes.button,
                                        btnValue === item.id ? [css.toggleInputButtonActive, classes.buttonActive] : ''
                                    ),
                                    ...stylers.button,
                                    ...(btnValue === item.id ? stylers.buttonActive : {})
                                },
                                icon: {
                                    className: classnames(
                                        css.toggleInputButtonIcon,
                                        classes.icon,
                                        btnValue === item.id ? [css.toggleInputButtonIconActive, classes.iconActive] : ''
                                    ),
                                    ...stylers.icon,
                                    ...(btnValue === item.id ? stylers.iconActive : {})
                                }
                            }
                        }),
                        {}
                    )
                }}
            />
        </>
    );
};
ToggleFormInput.propTypes = {
    title: PropTypes.object,
    buttonsAttribute: PropTypes.string,
    options: PropTypes.array,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    compStyle: PropTypes.object,
    setFormData: PropTypes.func,
    styles: PropTypes.object
};
export default ToggleFormInput;
